import storesController from './storesController'

export default storesController



// WEBPACK FOOTER //
// ../src/controllers/storesController/index.js